export default "__VITE_ASSET__AlcAEzyj__"